module.exports = __webpack_public_path__ + "img/2-1.6d8b5565.png";